<div class="container">
  <nx-message context="error">
    <span class="nx-font-weight-bold">{{ 'Oops! Something went wrong.' | transloco }}</span><br />
    {{ 'The service is temporarily unavailable. Please try again shortly.' | transloco }}<br />
    @if (debugId) {
      <span class="debug-id">
        {{ 'Debug ID:' | transloco }}
        {{ debugId }}
      </span>
    }
  </nx-message>
</div>
